import styled from 'styled-components';

const ViewResultBtnWrapper = styled.div`
  padding-right: 25px;
`;

export default ViewResultBtnWrapper;
